import DOMPurify from 'dompurify';
import { SANITIZE_CONFIG } from '@tools/shared';

export function sanitizeRichTextHtml(html: string): string {
  return DOMPurify.sanitize(html, SANITIZE_CONFIG);
}
